import styled from 'styled-components';
import { SecondaryButton } from '../../../global/styles';

export const StyledDeleteButton = styled(SecondaryButton)`
	svg {
		width: 12px;
		height: 12px;
		margin: 0px 4px;
		position: relative;
		top: 1px;
	}
`;
